module.exports = __webpack_public_path__ + "img/iot-02.29635968.png";